var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: _vm.reference, staticClass: "bg-video" },
    [
      _c(
        "video",
        {
          ref: "videoEl",
          staticClass: "video",
          class: _vm.videoClass,
          style: _vm.styles,
          attrs: {
            preload: _vm.preload,
            autoplay: _vm.autoplay ? true : false,
            playsinline: _vm.autoplay ? true : false,
            loop: _vm.loop ? true : false,
          },
          domProps: { muted: _vm.muted ? true : false },
        },
        [_c("source", { attrs: { src: _vm.src, type: "video/mp4" } })]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.poster && !_vm.playing
          ? _c(
              "div",
              {
                staticClass: "poster",
                style: { backgroundImage: "url(" + _vm.poster + ")" },
              },
              [
                _c("img", {
                  staticStyle: { display: "none" },
                  attrs: { src: _vm.poster, alt: "" },
                  on: { load: _vm.posterLoaded },
                }),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.overlay
        ? _c("div", {
            staticClass: "overlay-video",
            style: { backgroundColor: _vm.overlay },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.pattern
        ? _c("div", {
            staticClass: "overlay-pattern",
            style: { backgroundImage: "url(" + _vm.pattern + ")" },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.playing
        ? _c(
            "button",
            {
              staticClass: "btn-play",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.playVideo()
                },
              },
            },
            [_vm._t("btnplay")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.btns.fullscreen
        ? _c(
            "button",
            {
              staticClass: "video-full-btn",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.playFullscreen($event)
                },
              },
            },
            [_c("i", { staticClass: "icon-expand icon-l" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }